/**
 * Load More Button Module
 */
'use strict';

import doT from 'doT';

export default class loadMore {
    constructor() {
        //console.log('Load More module');

        let $listing = $('.listing-body'),
            $grid = $('.issues-list', $listing),
            $preloader = $('.preloader', $listing),
            $loadBtn = $('.loader', $listing),
            endpoint,
            ajax;

        if($listing.data('list-type') === 'articles') {
            $grid = $('.article-list', $listing);
        }

        /**
         * Loadmore button setup
         */
        {
            let visible = 0,
                takeCount = 3;

            if(!$listing.length) return;

            if($loadBtn.data('endpoint')) {
                endpoint = $loadBtn.data('endpoint')
            } else {
                $loadBtn.remove();
            }

            if($loadBtn.data('takecount')) takeCount = $loadBtn.data('takecount'); // If we are using take count

            $loadBtn.on('click', function(){
                visible = $('li', $grid).length;

                loadMoreItems(visible, takeCount);
            });
        }

        /**
         * Get Results from Endpoint
         */
        function loadMoreItems(visible, takeCount){
            var params = {
                'take': takeCount,
                'offset': visible
            }

            if(typeof ajax !== 'undefined') ajax.abort(); // Abort if Ajax request is ongoing

            $preloader.fadeIn();

            ajax = $.ajax({
                    url: endpoint,
                    data: params
                }).done(function(e){
                    $preloader.fadeOut();

                    var maxResults = e.Count,
                        currTake = e.Take;

                    var items = e.Articles || e.Issues; // Articles or Issues Results

                    renderItems(items);

                    if(visible + currTake >= maxResults) {
                        $loadBtn.fadeOut();
                    }
                });
        }

        /**
         * Append results to listings
         */
        function renderItems(o) {
            var i,
                template = doT.template($('#resultTemplate').html());

            for(i in o) {
                var item = o[i],
                    parentCats = item.ParentCategories;

                if(typeof parentCats !== 'undefined' && parentCats !== null) {

                    for(var x = 0; x < parentCats.length; x++){
                        parentCats[x] = parentCats[x].split('|');
                    }
                }

                if(parentCats === null) {
                    parentCats = []
                }

                $grid.append(template(item));
            }
        }
    }
}
